import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function INPC
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={30}
            adderFlag={22}
            showLabelInput={true}
            userConfiguration={true}
        />
    );
}
export default INPC